import DefaultLayout from "@/layouts/DefaultLayout";
import KNestedErrorsTable from "kinnect-general/KNestedErrorsTable";
import KPurchaseOrderErrorsTable from "kinnect-front/Sales/PurchaseOrders/KPurchaseOrderErrorsTable";
import KSalesOrderErrorsTable from "kinnect-front/Sales/SalesOrders/KSalesOrderErrorsTable";
import KScheduleForm from "kinnect-front/KYard/Schedule/KScheduleForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";
import { VCard } from "vuetify/lib";
import { YardSchedule } from "kinnect-models";

export default {
	name: "YardSchedulePage",

	metaInfo() {
		let title;

		if ( this.$route.name === "yardScheduleRequest" ) {
			title = "Yard - Request a Schedule";
		} else if ( this.editing ) {
			title = "Yard - Edit Schedule";
		} else {
			title = "Yard - Add a Schedule";
		}

		return { title };
	},

	props: { idSchedule: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "yard_schedules",
		deleteDialogOpen: false,
		schedule: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idSchedule );
		},

		genDeleteDialog() {
			if ( this.editing && this.schedule && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete schedule" )}
					onConfirm={() => this.schedule.delete()}
					redirect={[ "back", { name: "yardSchedules" } ]}
					title="Delete Schedule"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the <strong>{this.schedule.scheduleTypeNames}</strong> schedule for <strong>{this.schedule.address.address}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Schedule",
					tooltip: "Delete this schedule"
				};
			}
		},

		errorsTableItems() {
			if ( !this.schedule ) {
				return [];
			}

			return [
				{
					errorCount: this.schedule.purchaseOrderErrors.length,
					errorType: "Purchase Order",
					table: <KPurchaseOrderErrorsTable
						items={this.schedule.purchaseOrderErrors}
						loading={this.fetching}
					></KPurchaseOrderErrorsTable>
				},
				{
					errorCount: this.schedule.salesOrderErrors.length,
					errorType: "Sales Order",
					table: <KSalesOrderErrorsTable
						items={this.schedule.salesOrderErrors}
					></KSalesOrderErrorsTable>
				}
			];
		}
	},

	methods: {
		async fetchSchedule() {
			if ( this.editing ) {
				this.schedule = await YardSchedule
				.include(
					"purchase-orders.errors",
					"purchase-orders.errors.error-types",
					"purchase-orders.errors.purchase-orders",
					"sales-orders.errors",
					"sales-orders.errors.error-types",
					"sales-orders.errors.sales-orders"
				)
				.findPageModel( this.idSchedule );
			}
		},

		async fetch() {
			await this.fetchSchedule();
		}
	},

	render() {
		return <DefaultLayout maxWidth="700px">
			<KScheduleForm
				loading={this.$wait.is( "find schedule" )}
				readonly={this.editing ? !this.canEdit : false}
				schedule={this.schedule}
			></KScheduleForm>

			{this.editing && <VCard class="mt-4">
				<KNestedErrorsTable
					items={this.errorsTableItems}
					loading={this.$wait.is( "find schedule" )}
				></KNestedErrorsTable>
			</VCard>}

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
